// import React, { useState, useEffect } from 'react';
// import './Lero.css'; // Arquivo de estilo para o Lero (Head, Header, Slider)
// import { Link } from 'react-router-dom';

// const Lero = () => {
//   const [click, setClick] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const slides = [
//     {
//       image: 'ed2.jpg',
//       title: 'O Conteudo que Precisas',
//       subtitle: "Se é Moza, é Connosco ",
//       position: 'right',
//     },
//     {
//       image: 'ed3.jpg',
//       title: 'Tecnologias Que precisas',
//       subtitle: "Temos Várias Ferramentas para te",
//       position: 'center',
//     },
//     {
//       image: 'ed5.jpg',
//       title: 'Professores Qualificados',
//       subtitle: "Envoldidos em varias areas",
//       position: 'right',
//     },
//     {
//       image: 'ed12.jpg',
//       title: 'Curriculo Mocambicano',
//       subtitle: "Desde a Primaria a Universidade.",
//       position: 'center',
//     },
//   ];

//   const nextSlide = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
//   };

//   const prevSlide = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? slides.length - 1 : prevIndex - 1
//     );
//   };

//   useEffect(() => {
//     const intervalId = setInterval(nextSlide, 5000); // Troca a imagem a cada 5 segundos

//     return () => clearInterval(intervalId);
//   }, []);

//   return (
//     <div>
//       {/* Head */}
//       <section className="head">
//         <div className="container flexSB">
//           <div className="logo">
//           <img
//             src="/images/Asset7.png"
//             alt="Academia Logo"
//                className="logo-img"
//                 />
//             {/* <span>O Conteudo que Precisas</span> */}
//           </div>

//           <div className="social">
//             <i className="fab fa-facebook-f icon"></i>
//             <i className="fab fa-instagram icon"></i>
//             <i className="fab fa-twitter icon"></i>
//             <i className="fab fa-youtube icon"></i>
//           </div>
//         </div>
//       </section>

//       {/* Header */}
//       <header>
//         <nav className="flexSB">
//           <ul className={click ? 'mobile-nav' : 'flexSB '} onClick={() => setClick(false)}>
//             <li>
//               {/* <a href="/">Início</a> */}
//               <Link to="/" className='a'>Inicio</Link>
//             </li> 
//             <li>
//               {/* <a href="/quem-somos">Quem Somos</a> */}
//               <Link to="/AboutUs">Quem Somos</Link>
//             </li> 
//             <li>
//               {/* <a href="/sobre">Sobre</a> */}
//               <Link to="/AboutUs">Sobre-nos</Link>
//             </li>
//             <li>
//               {/* <a href="/contacto">Contacte-nos</a> */}
//               <Link to="/ContactUs">Contacte-nos</Link>
//             </li>
//             <li>
//               {/* <a href="/contacto">Baixe Coisas</a> */}
//               <Link to="/Downloads">Baixe Coisas</Link>
//             </li>
             
//           </ul>

//           <div className="start">
//           <ul>
//           <li><Link to="/login" className="but">
//               Iniciar Sessão
//             </Link></li>
//           </ul>  
//           </div>

//           <button className="toggle" onClick={() => setClick(!click)}>
//             {click ? <i className="fa fa-times"> </i> : <i className="fa fa-bars"></i>}
//           </button>
//         </nav>
//       </header>

//       {/* Slider */}
//       <div className="hero-slider">
//         <div
//           className="slider"
//           style={{
//             backgroundImage: `url(${process.env.PUBLIC_URL}/images/${slides[currentIndex].image})`,
//           }}
//         >
//           <div className={`caption ${slides[currentIndex].position} slide-animation`}>
//             <h3>{slides[currentIndex].title}</h3>
//             <h5>{slides[currentIndex].subtitle}</h5>
//           </div>

//           {/* Botões de navegação */}
//           <button className="prev" onClick={prevSlide}>
//             &#10094;
//           </button>
//           <button className="next" onClick={nextSlide}>
//             &#10095;
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Lero;

// YOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO

// import React, { useState, useEffect } from 'react';
// import './Lero.css';
// import { Link } from 'react-router-dom';

// const Lero = () => {
//   const [click, setClick] = useState(false);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   const slides = [
//     {
//       image: 'bg.webp',
//       title: 'O Conteudo que Precisas',
//       subtitle: 'Se e Moza e connosco',
//       position: 'left',
//     },
//     {
//       image: 'bg.webp',
//       title: 'As Ajudas Que precisas',
//       subtitle: 'Temos varias Ferramentas para te',
//       position: 'top',
//     },
//     {
//       image: 'bg.webp',
//       title: 'Professores Qualificados',
//       subtitle: '.',
//       position: 'right',
//     },
//     {
//       image: 'bg.webp',
//       title: 'Curriculo Mocambicano',
//       subtitle: 'Desde a Primaria a Universidade.',
//       position: 'center',
//     },
//   ];

//   const nextSlide = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
//   };

//   const prevSlide = () => {
//     setCurrentIndex((prevIndex) =>
//       prevIndex === 0 ? slides.length - 1 : prevIndex - 1
//     );
//   };

//   useEffect(() => {
//     const intervalId = setInterval(nextSlide, 5000);
//     return () => clearInterval(intervalId);
//   }, []);

//   return (
//     <div>
//       {/* Head */}
//       <section className="head">
//         <div className="container flexSB">
//           <div className="logo">
//             <img
//               src="/images/Asset7.png"
//               alt="Academia Logo"
//               className="logo-img"
//             />
//           </div>

//           <div className="social">
//             <i className="fab fa-facebook-f icon"></i>
//             <i className="fab fa-instagram icon"></i>
//             {/* <i className="fab fa-twitter icon"></i> */}
//             <i className="fab fa-youtube icon"></i>
//           </div>
//         </div>
//       </section>

//       {/* Header */}
//       <header>
//         <nav className="flexSB">
//           <ul className={click ? 'mobile-nav' : 'flexSB'} onClick={() => setClick(false)}>
//             <li>
//               <Link to="/">Início</Link>
//             </li>
//             <li>
//               <Link to="/AboutUs">Quem Somos</Link>
//             </li>
//             <li>
//               <Link to="/ContentPage">Conteúdo</Link>
//             </li>
//             <li>
//               <Link to="/contacto">Contacte-nos</Link>
//             </li>
//             <li>
//               <Link to="/downloads">Baixe Coisas</Link>
//             </li>
//           </ul>

//           <div className="start">
//             <Link to="/login" className="button">
//               Iniciar Sessão
//             </Link>
//           </div>

//           <button className="toggle" onClick={() => setClick(!click)}>
//             {click ? <i className="fa fa-times"></i> : <i className="fa fa-bars"></i>}
//           </button>
//         </nav>
//       </header>

//       {/* Slider */}
//       <div className="hero-slider">
//         <div
//           className="slider"
//           style={{
//             backgroundImage: `url(${process.env.PUBLIC_URL}/images/${slides[currentIndex].image})`,
//           }}
//         >
//           <div className={`caption ${slides[currentIndex].position} slide-animation`}>
//             <h3>{slides[currentIndex].title}</h3>
//             <h5>{slides[currentIndex].subtitle}</h5>
//           </div>

//           {/* Botões de navegação */}
//           <button className="prev" onClick={prevSlide}>
//             ❮
//           </button>
//           <button className="next" onClick={nextSlide}>
//             ❯
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Lero;

// hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh

import React, { useState, useEffect } from 'react';
// import './Lero.css';
import './Lerro.css';
import Header from './Header';

const Lero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const slides = [
    {
      image: 'ed2.jpg',
      title: 'O Conteudo que Precisas',
      subtitle: "Se é Moza, é Connosco ",
      position: 'right',
    },
    {
      image: 'ed3.jpg',
      title: 'Tecnologias Que precisas',
      subtitle: "Temos Várias Ferramentas para te",
      position: 'center',
    },
    {
      image: 'ed5.jpg',
      title: 'Professores Qualificados',
      subtitle: "Envoldidos em varias areas",
      position: 'right',
    },
    {
      image: 'ed12.jpg',
      title: 'Curriculo Mocambicano',
      subtitle: "Desde a Primaria a Universidade.",
      position: 'center',
    },
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? slides.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const intervalId = setInterval(nextSlide, 5000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      <Header />

      {/* Slider */}
      <div className="hero-slider">
        <div
          className="slider"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/${slides[currentIndex].image})`,
          }}
        >
          <div className={`caption ${slides[currentIndex].position} slide-animation`}>
            <h3>{slides[currentIndex].title}</h3>
            <h5>{slides[currentIndex].subtitle}</h5>
          </div>

          <button className="prev" onClick={prevSlide}>
            &#10094;
          </button>
          <button className="next" onClick={nextSlide}>
            &#10095;
          </button>
        </div>
      </div>
    </div>
  );
};

export default Lero;
